import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NavController, Platform} from "@ionic/angular";
import {Location} from "@angular/common";
import {collection, deleteDoc, doc, getDoc, onSnapshot, query, updateDoc, where} from "firebase/firestore";
import {RestService} from "../../services/rest.service";
import {UtilService} from "../../services/util.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  styleUrls: ['./notifications.page.scss'],
})
export class NotificationsPage implements OnInit, OnDestroy {
  @ViewChild('popoverNotificationNested') popoverNotificationNested;
  showOverSearch: boolean;
  searchTop: any;
  helpFocus: boolean;
  isMobile: boolean;
  loadMostWanted: any;
  selectedNotificationType: 'all' | 'read' | 'unread' = 'all';
  notifications: any[] = [];
  filteredNotifications: any[] = [];
  unsubscribe: any;
  user: any;
  currentUserId: string;
  itemNotification: any;
  isOpenNotificationNested = false;

  constructor(
    public navCtrl: NavController,
    private locationRouter: Location,
    public platform: Platform,
    public rest: RestService,
    private translate: TranslateService,
    public util: UtilService,
  ) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
  }

  ngOnDestroy(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  async ngOnInit() {
    await this.rest.getStorage('user').then((val) => {
      this.user = val;
      this.currentUserId = this.user.id + '';
    });
    this.subscribeToChanges();
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }
  gotoOldApp(view?) {
    console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }
  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      // this.banners = ev.banners
    }
    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

  getReadNotifications() {
    this.selectedNotificationType = 'read';
    this.filteredNotifications = this.notifications.filter(value => value.readed);
  }

  getUnreadNotifications() {
    this.selectedNotificationType = 'unread';
    this.filteredNotifications = this.notifications.filter(value => !value.readed);
  }

  getAllNotifications() {
    this.selectedNotificationType = 'all';
    this.filteredNotifications = this.notifications;
  }

  getTime(notifTime) {
    const currentTime = new Date().getTime();
    const timeElapsed = Math.abs(currentTime - notifTime);

    const seconds = Math.round(timeElapsed / 1000);
    const minutes = Math.round(timeElapsed / 1000 / 60);
    const hours = Math.round(timeElapsed / 1000 / 60 / 60);
    const days = Math.round(timeElapsed / 1000 / 60 / 60/ 24);

    if (days > 1) {
      return this.translate.instant('HACE') + days + this.translate.instant('DAYS');
    }
    if (days === 1) {
      return this.translate.instant('HACE') + days + this.translate.instant('DAY');
    }
    if (hours > 1) {
      return this.translate.instant('HACE') + hours + this.translate.instant('HOURS');
    }
    if (hours === 1) {
      return this.translate.instant('HACE') + hours + this.translate.instant('HOUR');
    }
    if (minutes > 0) {
      return this.translate.instant('HACE') + minutes + this.translate.instant('MINUTES');
    }

    return this.translate.instant('HACE')+ seconds + this.translate.instant('SECONDS');
  }

  subscribeToChanges() {
    const q = query(collection(this.util.db, "notificaciones"), where("receiver", "==", this.currentUserId));
    this.unsubscribe = onSnapshot(q, (querySnapshot) => {
      querySnapshot.docChanges().forEach((notif) => {
        if (notif.type === 'removed') {
          this.notifications = [...this.notifications.filter(value => value.id !== notif.doc.id)];
          this.filteredNotifications = this.filteredNotifications.filter(value => value.id !== notif.doc.id);
          return;
        }

        this.notifications = [{ id: notif.doc.id, ...notif.doc.data() }, ...this.notifications
          .filter(value => value.id !== notif.doc.id)];

        this.filteredNotifications = this.filteredNotifications.filter(value => value.id !== notif.doc.id);
        if (this.selectedNotificationType === 'all'
          || (this.selectedNotificationType === 'read' && notif.doc.data().readed)
          || (this.selectedNotificationType === 'unread' && notif.doc.data().readed)) {
          this.filteredNotifications = [{ id: notif.doc.id, ...notif.doc.data() }, ...this.filteredNotifications];
        }
      });
    });
  }

  goToChat(item) {
    if (!item.readed) {
      updateDoc(doc(this.util.db, 'notificaciones', item.id), {
        readed: true
      });
    }
    this.navCtrl.navigateForward('/mensajes/usuario/' + item.emisor);
  }

  markAsRead() {
    if (!this.itemNotification.readed) {
      updateDoc(doc(this.util.db, 'notificaciones', this.itemNotification.id), {
        readed: true
      });
    }
    this.popoverNotificationNested.dismiss();
  }

  markAsUnread() {
    if (this.itemNotification.readed) {
      updateDoc(doc(this.util.db, 'notificaciones', this.itemNotification.id), {
        readed: false
      });
    }
    this.popoverNotificationNested.dismiss();
  }

  deletedNotification() {
    if (this.itemNotification.id) {
      deleteDoc(doc(this.util.db, 'notificaciones', this.itemNotification.id));
    }
    this.popoverNotificationNested.dismiss();
  }

  showNewNotification() {
    return this.notifications && this.notifications.some(value => !value.readed);
  }

  presentPopoverNotificationNested(e: Event, item) {
    this.popoverNotificationNested.event = e;
    this.isOpenNotificationNested = true;
    this.itemNotification = item;
  }
}
